module.exports = __webpack_public_path__ + "static/media/logo.f1eacde2.png";